import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { FeatureFlagsService } from '../feature-flags-service/feature-flags.service';

// Loads the Financeify Convert Experiences A/B test script, gated by the
// 'financeify-convert-experiences-script' feature flag (default false in every environment --
// see FEATURE-FLAGS.md). The test concluded and was hard-coded into the funnels already, so this
// now only exists as a kill switch (Asana 1217647730328354), not as a live A/B test.
@Injectable({
  providedIn: 'root',
})
export class ConvertExperiencesService {
  // Verbatim copy of the allowlist that used to live inline in src/index.html. Deliberately NOT
  // reused/merged with src/assets/data/urls-for-brand.ts's `financeify` array (missing
  // financeify.net/www.financeify.net, and not a 1:1 match otherwise) to avoid silently changing
  // which hosts get the script the day this flag is flipped back on.
  private readonly allowedHosts = [
    'financeify.co', 'www.financeify.co', 'stage.financeify.co', 'members.financeify.co',
    'www.financeify.net', 'financeify.net',
  ];

  constructor(private featureFlagsService: FeatureFlagsService) {}

  public initConvertExperiences(): void {
    if (this.allowedHosts.indexOf(this.getHostname()) === -1) {
      return;
    }
    this.featureFlagsService
      .isEnabled('financeify-convert-experiences-script')
      .pipe(first())
      .subscribe((enabled) => {
        if (enabled) {
          this.loadScript();
        }
      });
  }

  // Extracted so tests can stub it -- window.location.hostname is non-configurable in this
  // repo's target browsers, so spyOnProperty/Object.defineProperty on it fails at test time.
  private getHostname(): string {
    return window.location.hostname;
  }

  // document.write (the original inline mechanism) is only safe while the document is still
  // being parsed. Calling it here -- long after Angular has bootstrapped -- would wipe the whole
  // page. createElement + appendChild is the same async-script pattern index.html already uses
  // for its own deferred GTM snippet.
  private loadScript(): void {
    if (document.head.querySelector('script[src*="convertexperiments.com"]')) {
      return;
    }
    const script = document.createElement('script');
    script.src = '//cdn-4.convertexperiments.com/v1/js/10019332-10019685.js?environment=production';
    script.async = true;
    document.head.appendChild(script);
  }
}
